module.exports = __webpack_public_path__ + "static/scale-model-of-chicago-water-tower-in-chicago-illinois-04b52093771ffc5538d609a681971024.png";